"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18076],{

/***/ 18076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96076);




var DefaultFooter = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(6778), __webpack_require__.e(64037)]).then(__webpack_require__.bind(__webpack_require__, 64037));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64037)
            ];
        }
    }
});
var Footer = function() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), project = ref.query.project;
    if (utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .CASE_STUDIES_SLUGS.includes */ .id.includes(project)) {
        return;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultFooter, {});
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ })

}]);